import React, { Component } from 'react';
import accounting from 'accounting';
import moment from 'moment';
import { Row, Col, Button, FormGroup, ControlLabel, FormControl, Modal, Table, Label, Alert, } from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class AddIncentiveModal extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            error: null,
            adjustment: null,
        };
    }
    handleChange(field) {
        return (e) => {
            const value = e.target.value;
            this.setState({ [field]: value });
        };
    }
    addIncentive() {
        const { t } = this.props;
        return (e) => {
            const adjustment = {
                value: this.state.adjustmentValue,
                message: t('INCENTIVE_PAYMENT'),
                type: 'incentive_payment',
                category: 'incentive_payments',
            };
            if (!adjustment.value) {
                return this.setState({ error: t('ADJUSTMENT_AMOUNT_FIELD_ERROR') });
            }
            this.props.addIncentive(adjustment);
            this.props.onHide();
        };
    }
    renderInput() {
        return (React.createElement(FormGroup, null,
            React.createElement(ControlLabel, null, "$ \u00A0"),
            React.createElement(FormControl, { type: "number", onChange: this.handleChange('adjustmentValue') })));
    }
    renderError() {
        if (!this.state.error) {
            return '';
        }
        return React.createElement(Alert, { bsStyle: "warning" }, this.state.error);
    }
    renderIncentiveFlow() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("p", { className: "lead" },
                        t('AMOUNT_TO_ADD_TO_SHIPMENT'),
                        " "),
                    React.createElement("div", { className: "form-inline" }, this.renderInput())))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.show, onHide: this.props.onHide, enforceFocus: false },
            React.createElement(Modal.Body, null,
                this.renderError(),
                this.renderIncentiveFlow()),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: this.props.onHide }, titleize(t('CLOSE'))),
                React.createElement(Button, { bsStyle: "primary", onClick: this.addIncentive() }, titleize(t('SAVE'))))));
    }
}
export default withTranslation()(AddIncentiveModal);
